import { findPriceByName } from './ingredientMatch';
import { usableG } from './priceYield';   // V152 실사용량 (신선식품 로스 제외)
// ── 레시피 + 메뉴 판매수량 → 식재료 일별 소비량 자동 산출 ────────────
// 발주 내역 없는 신규 매장도 즉시 활용 가능

// 메뉴 1인분당 식재료 사용량(g) = ing.qty * (item.serving_g / item.total_output)
// 메뉴 월 판매수 = expectedMonthlyServings / 메뉴 개수 (균등 분할 v1)
// 메뉴별 월 식재료 사용량(g) = 1인분 사용량 * 월 판매수
// 식재료 단위 변환:
//   prices[name].unit / prices[name].net_g 으로 g → unit 환산
//   net_g 0 또는 unit이 'g'이면 g 그대로

export function calcRecipeBasedUsage(categories, prices, expectedMonthlyServings) {
  if (!categories || !Array.isArray(categories)) return {};
  if (!prices || !Array.isArray(prices)) return {};
  const total = Number(expectedMonthlyServings) || 0;
  if (total <= 0) return {};

  // 판매가능 메뉴(type === 'menu' && selling_price > 0) 모으기 — 가능하면 selling_price 입력된 것만
  // 없으면 모든 메뉴 (selling_price 없어도) 균등 분할
  const allMenus = [];
  categories.forEach(cat => {
    (cat.items || []).forEach(it => {
      if (it.type === 'menu') allMenus.push(it);
    });
  });
  if (allMenus.length === 0) return {};

  const menusWithPrice = allMenus.filter(m => (Number(m.selling_price) || 0) > 0);
  const targetMenus = menusWithPrice.length > 0 ? menusWithPrice : allMenus;
  const perMenuMonthly = total / targetMenus.length;

  // 식재료별 월 사용량(g) 합산
  const usageGrams = {};
  targetMenus.forEach(menu => {
    const totalOutput = Number(menu.total_output) || 0;
    const servingG = Number(menu.serving_g) || 0;
    if (totalOutput <= 0 || servingG <= 0) return;
    const ratio = servingG / totalOutput;  // 1인분당 비율
    (menu.ingredients || []).forEach(ing => {
      const qty = Number(ing.qty) || 0;
      if (qty <= 0) return;
      const perServingG = qty * ratio;  // 1인분당 식재료 사용량(g)
      const monthlyG = perServingG * perMenuMonthly;
      usageGrams[ing.name] = (usageGrams[ing.name] || 0) + monthlyG;
    });
  });

  // 단위 변환 (prices의 unit 기준)
  const result = {};
  Object.entries(usageGrams).forEach(([name, gramsPerMonth]) => {
    const price = findPriceByName(prices, name);
    let avgMonthly, unit;
    if (price && usableG(price) > 0 && price.unit && price.unit !== 'g') {
      // g → unit (예: 1박스=1000g이면 박스 단위로 환산). V152: 신선식품은 로스를 뺀 실사용량으로 나눈다
      avgMonthly = gramsPerMonth / usableG(price);
      unit = price.unit;
    } else {
      avgMonthly = gramsPerMonth;
      unit = price?.unit || 'g';
    }
    result[name] = {
      avgMonthly,
      avgDaily: avgMonthly / 30,
      unit,
      dataMonths: 0,
      source: 'recipe',
    };
  });
  return result;
}
